<template>
  <div class="p-grid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <b>{{ title }}</b>
          <Button label="Lưu" class="p-button-sm p-button-success" 
            style="float:right;color: white !important;background-color: #32D74B !important;border: 1px solid #32D74B !important;" 
            @click="saveData()"/>
          <Button label="Quay lại" class="p-button-sm p-button-warning" 
            style="float:right;margin-right: 10px;color: black !important;background-color: #FFD60A !important;border: 1px solid #FFD60A !important;" 
            @click="backToList()"/>
        </div>
        <div class="block p-fluid p-formgrid p-grid" style="border: 1px solid #c8c8c8; padding: 10px;">
          <div class="block-left p-field p-col-12 p-md-6">
            <div>
              <p class = "block-title">Thông tin văn bản</p>
              <div class="p-field p-grid" v-if="mode == 'edit'">
                <label for="codeSystem" class="p-col-fixed" style="width:100px">Mã VB hệ thống</label>
                <div class="p-col">
                  <InputText id="codeSystem" type="text" class="custom-disabled" :disabled="true" v-model="codeSystem" placeholder="Nhập mã hệ thống"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="codeCourt" class="p-col-fixed" style="width:100px">Mã VB tòa</label>
                <div class="p-col">
                  <InputText id="codeCourt" class="custom-disabled" :disabled="true" type="text" v-model="codeCourt" placeholder="Nhập mã tòa"/>
                  <small
                    v-if="validationErrors && validationErrors['codeCourt']"
                    class="p-invalid"
                  >{{validationErrors['codeCourt']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="codeOffice" class="p-col-fixed" style="width:100px;">Mã văn phòng</label>
                <div class="p-col">
                  <InputText id="codeOffice" class="custom-disabled" :disabled="true" type="text" v-model="codeOffice" placeholder="Nhập mã văn phòng"/>
                  <small
                    v-if="validationErrors && validationErrors['codeOffice']"
                    class="p-invalid"
                  >{{validationErrors['codeOffice']}}</small>
                  <small
                    v-if="cOffice_exists"
                    class="p-invalid"
                  >Mã văn phòng không tồn tại</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="isUrgent" class="p-col-fixed" style="width:100px">Văn bản gấp</label>
                <div class="p-col">
                  <Checkbox v-model="isUrgent" :binary="true" />
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="numberDecision" class="p-col-fixed" style="width:100px">Quyết định số</label>
                <div class="p-col">
                  <InputText id="numberDecision" type="text" v-model="numberDecision" placeholder="Nhập quyết định số"/>
                  <small
                    v-if="validationErrors && validationErrors['numberDecision']"
                    class="p-invalid"
                  >{{validationErrors['numberDecision']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="contentDocument" class="p-col-fixed" style="width:100px">Nội dung văn bản</label>
                <div class="p-col">
                  <InputText id="contentDocument" type="text" v-model="contentDocument" placeholder="Nhập nội dung"/>
                  <small
                    v-if="validationErrors && validationErrors['contentDocument']"
                    class="p-invalid"
                  >{{validationErrors['contentDocument']}}</small>
                </div>
              </div>
              <div class="p-grid">
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <div class="p-field p-grid" style="margin-bottom: 0;">
                    <label for="dateIssued" class="p-col-fixed" style="width:100px">Ngày ban hành</label>
                    <div class="p-col">
                      <Calendar v-model="dateIssued" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" />
                    </div>
                  </div>
                </div>
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <div class="p-field p-grid" style="margin-bottom: 0;">
                    <label for="dateInvite" class="p-col-fixed" style="width:100px">Ngày mời*</label>
                    <div class="p-col">
                      <Calendar v-model="dateInvite" dateFormat="dd/mm/yy" :showIcon="true" @input="onChangeDate($event, 'invite')"/>
                      <small
                        v-if="validationErrors && validationErrors['dateInvite']"
                        class="p-invalid"
                      >{{validationErrors['dateInvite']}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p class="block-title">Thông tin đương sự</p>
              <div class="p-field p-grid">
                <label for="nameLitigant" class="p-col-fixed" style="width:100px">Tên đương sự*</label>
                <div class="p-col">
                  <InputText id="nameLitigant" type="text" v-model="nameLitigant" placeholder="Nhập tên đương sự"/>
                  <small
                    v-if="validationErrors && validationErrors['nameLitigant']"
                    class="p-invalid"
                  >{{validationErrors['nameLitigant']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="stateID" class="p-col-fixed" style="width:100px">Tỉnh/thành phố*</label>
                <div class="p-col">
                  <!-- <InputText id="stateID" type="text" v-model="stateID" placeholder="Chọn Tỉnh/ Thành phố"/> -->
                  <Dropdown :key="countState" id="stateID" class="p-column-filter" :showClear="true" :filter="true" v-model="state" :options="arrState" optionLabel="name" @change="onChangeState()" placeholder="Chọn Tỉnh/ Thành phố"/><!--onChangeState($event)-->
                  <small
                    v-if="validationErrors && validationErrors['state']"
                    class="p-invalid"
                  >{{validationErrors['state']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="districtID" class="p-col-fixed" style="width:100px">Quận/huyện*</label>
                <div class="p-col">
                  <!-- <InputText id="districtID" type="text" v-model="districtID" placeholder="Chọn Quận/ Huyện"/> -->
                  <Dropdown :key="countDist" id="districtID" :showClear="true" :filter="true" v-model="district" :options="arrDistrict" optionLabel="name" @change="onChangeDistrict($event)" placeholder="Chọn Quận/ Huyện"/>
                  <small
                    v-if="validationErrors && validationErrors['district']"
                    class="p-invalid"
                  >{{validationErrors['district']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="wardID" class="p-col-fixed" style="width:100px">Phường/xã*</label>
                <div class="p-col">
                  <!-- <InputText id="wardID" type="text" v-model="wardID" placeholder="Chọn Phường/ Xã"/> -->
                  <Dropdown :key="countWard" id="wardID" :showClear="true" :filter="true" v-model="ward" :options="arrWard" optionLabel="name" @change="onChangeWard()" placeholder="Chọn Phường/ Xã"/><!--onChangeWard($event)-->
                  <small
                    v-if="validationErrors && validationErrors['ward']"
                    class="p-invalid"
                  >{{validationErrors['ward']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="address" class="p-col-fixed" style="width:100px">Địa chỉ</label>
                <div class="p-col">
                  <InputText id="address" type="text" v-model="address" placeholder="Nhập địa chỉ"/>
                  <small
                    v-if="validationErrors && validationErrors['address']"
                    class="p-invalid"
                  >{{validationErrors['address']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="phoneLitigant" class="p-col-fixed" style="width:100px">Số điện thoại</label>
                <div class="p-col">
                  <InputText v-model="phoneLitigant" id="phoneLitigant" type="number" class="p-col-width" placeholder="Nhập số điện thoại"/>
                </div>
              </div>
            </div>
            <div>
              <p class="block-title">Hình thức tống đạt: Không thành / Niêm Yết</p>
              <div class="block-history p-grid" v-for="(item, index) in arrLogs" :key="index">
                <div class="obj-title p-col">Đối tượng: {{item.objectName}}</div>
                <div class="obj-item p-col-12">
                  <div>Ngày gửi phường</div>
                  <div>{{item.dateSent}}</div>
                </div>
                <div class="obj-item p-col-12">
                  <div>Tên tư pháp</div>
                  <div>{{item.personal}}</div>
                </div>
                <div class="obj-item p-col-12">
                  <div>Ngày hẹn lại</div>
                  <div>{{item.dateAppointment}}</div>
                </div>
                <div class="obj-item p-col-12">
                  <div>Trạng thái</div>
                  <div>{{item.statusName}}</div>
                </div>
                <div class="obj-item p-col-12">
                  <div>Lý do</div>
                  <div>{{item.reason}}</div>
                </div>
                <div class="obj-item p-col-12" style="margin-bottom: 16px;">
                  <div>Ghi chú</div>
                  <div>{{item.note}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="p-field p-col-12 p-md-2"/> -->
          <div class="block-right p-field p-col-12 p-md-6">
            <div>
              <p class="block-title">Thông tin cơ quan giao</p>
              <div class="p-field p-grid">
                <label for="signer" class="p-col-fixed" style="width:100px">Người ký</label>
                <div class="p-col">
                  <InputText id="signer" type="text" v-model="signer" placeholder="Nhập tên thẩm phán/chấp hành viên"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="codeAgency" class="p-col-fixed" style="width:100px">Mã cơ quan</label>
                <div class="p-col">
                  <InputText id="codeAgency" class="custom-disabled" :disabled="true" type="text" v-model="codeAgency" placeholder="Nhập mã cơ quan"/>
                  <small
                    v-if="validationErrors && validationErrors['codeAgency']"
                    class="p-invalid"
                  >{{validationErrors['codeAgency']}}</small>
                  <small
                    v-if="cAgency_exists"
                    class="p-invalid"
                  >Mã cơ quan không tồn tại</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="costDocument" class="p-col-fixed" style="width:100px">Chi phí cơ quan trả</label>
                <div class="p-col">
                  <InputText :disabled="mode == 'edit'" v-model="costDocument" id="costDocument" type="number" class="p-col-width custom-disabled" placeholder="Nhập chi phí đi Tỉnh hoặc hệ thống sẽ hiển thị nếu Nội Thành"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="" class="p-col-fixed" style="width:100px">Đối tượng chịu phí</label>
                <div class="p-grid p-fluid">
                  <div class="p-col-12 p-md-6" style="width: 120px;">
                    <RadioButton name="actionBudget" value="ybudget" v-model="isFeeBudget" />
                    <label style="display: unset; margin: 5px;">Ngân sách</label>
                  </div>
                  <div class="p-col-12 p-md-6" style="width: 120px;">
                    <RadioButton name="actionBudget" value="nbudget" v-model="isFeeBudget" />
                    <label style="display: unset; margin: 5px;">Đương sự</label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p class="block-title">Thông tin Tống Đạt Viên/ Văn phòng liên kết</p>
              <div class="p-field p-grid">
                <label for="nameTDV" class="p-col-fixed" style="width:100px">Họ và tên TĐV</label>
                <div class="p-col">
                  <!-- <InputText id="nameTDV" type="text" v-model="nameTDV" placeholder="Chọn Tống Đạt viên"/> -->
                  <Dropdown :key="countTDV" id="nameTDV" class="p-column-filter" :showClear="true" :filter="true" @change="onChangeTDV($event)" v-model="nameTDV" :options="arrTDV" optionLabel="name" placeholder="Chọn Tống Đạt viên"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="firstname" class="p-col-fixed" style="width:100px">Số điện thoại</label>
                <div class="p-col">
                  <InputText :disabled="true" v-model="phoneTDV" id="phoneTDV" type="number" class="p-col-width" placeholder="Nhập số điện thoại"/>
                </div>
              </div>
              <div class="p-field p-grid" v-if="this.$store.getters.role != 'court'">
                <label for="codeVPLK" class="p-col-fixed" style="width:101px; padding-right:0;">Mã văn phòng liên kết</label>
                <div class="p-col">
                  <Dropdown :key="countVPLK"  id="codeVPLK" class="p-column-filter" :showClear="true" v-model="codeVPLK" :options="arrVPLK" optionLabel="name" placeholder="Chọn văn phòng liên kết"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="firstname" class="p-col-fixed" style="width:100px">Loại văn bản*</label>
                <div class="p-col">
                  <Dropdown id="typeDoc" v-model="type" :options="typeDocs" optionLabel="name"/>
                </div>
              </div>
            </div>
            <div>
              <p class="block-title">Thông tin Tống Đạt</p>
              <div class="p-field p-grid">
                <label for="statusVB" class="p-col-fixed" style="width:100px">Trạng thái VB</label>
                <div class="p-col">
                  <Dropdown :key="countSVB" id="statusVB" class="p-column-filter status-vb" :showClear="true" :filter="true" v-model="statusVB" :options="arrStatusVB" @change="onChangeTTVB($event, 'vb')" optionLabel="name" placeholder="Chọn Trạng thái VB"/>
                  <small
                    v-if="validationErrors && validationErrors['statusVB']"
                    class="p-invalid"
                  >{{validationErrors['statusVB']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="statusTD" class="p-col-fixed" style="width:100px">Hình thức TĐ</label>
                <div class="p-col">
                  <Dropdown :key="countSTD" id="statusTD" class="p-column-filter status-td" :showClear="true" :filter="true" v-model="statusTD" :options="arrStatusTD" @change="onChangeTTVB($event, 'td')" optionLabel="name" placeholder="Chọn Hình thức TĐ"/>
                  <small
                    v-if="validationErrors && validationErrors['statusTD']"
                    class="p-invalid"
                  >{{validationErrors['statusTD']}}</small>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="reasonDelay" class="p-col-fixed" style="width:100px">Lý do trễ</label>
                <div class="p-col">
                  <InputText id="reasonDelay" type="text" v-model="reasonDelay" placeholder="Tống Đạt Viên nhập lý do trễ"/>
                </div>
              </div>
              <div class="p-field p-grid">
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <div class="p-field p-grid" style="margin-bottom: 16px;">
                    <label for="dateReceiptCourt" class="p-col-fixed" style="width:100px;padding-right:0;">Ngày hoàn thành VB</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateReceiptCourt" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true" />
                    </div>
                  </div>
                  <div class="p-field p-grid" style="margin-bottom: 16px;">
                    <label for="dateTDVReturn" class="p-col-fixed" style="width:100px;padding-right:0;">Ngày TĐV giao lại VB</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateTDVReturn" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true"/>
                    </div>
                  </div>
                  <div class="p-field p-grid" style="margin-bottom: 16px;">
                    <label for="dateRequestComplete" class="p-col-fixed" style="width:100px;padding-right:0;">Ngày yêu cầu hoàn thiện lại</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateRequestComplete" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true"/>
                    </div>
                  </div>
                  <div class="p-field p-grid" style="margin-bottom: 0;">
                    <label for="dateReturnCourt" class="p-col-fixed" style="width:100px">Ngày trả tòa</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateReturnCourt" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true"/>
                    </div>
                  </div>
                </div>
                <div class="p-field p-col-12 p-md-6" style="margin-bottom: 0;">
                  <div class="p-field p-grid" style="margin-bottom: 16px;">
                    <label for="dateTDVReceipt" class="p-col-fixed" style="width:100px;padding-right:0;">Ngày TĐV nhận văn bản</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateTDVReceipt" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true" />
                    </div>
                  </div>
                  <div class="p-field p-grid" style="margin-bottom: 16px;">
                    <label for="dateDPVReceipt" class="p-col-fixed" style="width:100px;padding-right:0;">Ngày ĐPV nhận lại VB</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateDPVReceipt" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true" />
                    </div>
                  </div>
                  <div class="p-field p-grid" style="margin-bottom: 16px;">
                    <label for="dateComplete" class="p-col-fixed" style="width:100px;padding-right:0;">Ngày VB hoàn thành</label>
                    <div class="p-col">
                      <Calendar v-model="dateValue.dateComplete" class="custom-disabled" :disabled="true" dateFormat="dd/mm/yy" :showTime="true"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-field p-grid">
                <label for="note" class="p-col-fixed" style="width:100px;padding-right:0;">Ghi chú Tống Đạt Viên</label>
                <div class="p-col">
                  <Textarea placeholder="Nhập nội dung ghi chú" v-model="note" rows="5" cols="30" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import graphql from '../common/graphql'
// import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import moment from "moment-timezone";
import store from '@/store'
export default {
  components: {
    // moment
  },
  data() {
    return {
      title: "Chỉnh sửa văn bản",
      mode: 'edit',
      models: {},
      componentKey: 0,
      arrState: [],
      arrDistrict: [],
      arrWard: [],
      codeSystem: '',
      codeCourt: '',
      codeOffice: '',
      codeOfficeID: null,
      isUrgent: false,
      numberDecision: '',
      contentDocument: '',
      dateIssued: new Date(),
      dateInvite: null,
      nameLitigant: '',
      address: '',
      state: null,
      ward: null,
      district: null,
      phoneLitigant: null,
      signer: null,
      codeAgency: '',
      codeAgencyID: null,
      costDocument: '',
      isFeeBudget: null,
      nameTDV: null,
      arrTDV: [],
      phoneTDV: '',
      codeVPLK: null,
      arrVPLK: [],
      type: null,
      typeDocs: [
        {name: 'Loại 1', code: 1}, // VB gửi đương sự, 1 địa chỉ, 1 ngày nhập VB
        {name: 'Loại 2', code: 2}, // giống loại 1, khác đương sự
        {name: 'Loại 3', code: 3}, // cùng đượng sự, cùng ngày nhập, cùng địa chỉ
        {name: 'Loại 4', code: 4}, // VB trả tòa (thất lạc)
        {name: 'Loại 5', code: 5} // VB đi tỉnh
      ],
      statusVB: null,
      arrStatusVB: [],
      statusTD: null,
      arrStatusTD: [],
      reasonDelay: '',
      note: '',
      dateReceiptCourt: null,
      dateTDVReceipt: null,
      dateTDVReturn: null,
      dateDPVReceipt: null,
      dateRequestComplete: null,
      dateComplete: null,
      dateReturnCourt: null,
      dateValue:this.$constants.DATE_VALUE,
      countState: 0,
      countDist: 0,
      countWard: 0,
      countTDV: 0,
      countVPLK: 0,
      countSVB: 0,
      countSTD: 0,
      validationErrors: {},
      cAgency_exists: false,
      cOffice_exists: false,
      dateUpdate: [],
      arrLogs: [],
      lstObjectLog: [
        {'name': 'Tổ trưởng', code: 1},
        {'name': 'CSKV', code: 2},
        {'name': 'Tư pháp', code: 3},
        {'name': 'Khác', code: 4}
      ],
      lstStatusLog: [
        {'name': 'Ký', code: 1},
        {'name': 'Không ký', code: 2},
        {'name': 'Hẹn lại', code: 3}
      ],
      deadline: false,
      amountSalary: 0,
      checkDateNull: false,
    }
  },
  async mounted () {
    var hasEditAfterSalaryPermission = store.getters.group_permission && store.getters.group_permission.edit_document_after_salary && store.getters.group_permission.edit_document_after_salary.edit == true;
    if (store.getters.group_permission && store.getters.group_permission.report_late_undone.edit == false && store.getters.role != "admin" && !hasEditAfterSalaryPermission) {
      this.$router.push({name: '404'})
    }
    this.mode = this.$route.name === 'editDoc' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Chỉnh sửa văn bản' : this.title;
    if (this.$route.params.id !== undefined) {
      await this.getData(this.$route.params.id);
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/report-uncomplete-late' });
    },
    async checkCode(model, code) {
      await this.$apollo.query({
        query: DataServices.getList(model, {"fields" : "id code"}),
        variables: {
          where_key: {
            code: {'_eq': code.trim()},
            deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      }).then((res) => {
        if (model === 'office_tpl') {
          this.cOffice_exists = false
          if (res.data && res.data[Object.keys(res.data)].length === 0) {
            this.cOffice_exists = true
          } else {
            this.codeOfficeID = res.data.office_tpl[0].id
          }
        } else {
          this.cAgency_exists = false
          if (res.data && res.data[Object.keys(res.data)].length === 0) {
            this.cAgency_exists = true
          } else {
            this.codeAgencyID = res.data.office_agency[0].id
          }
        }
      })
    },
    async checkDateVBOnServer(docID, date) {
      let objWhere = {
        deleted: {'_eq': false},
        id: {'_eq': docID}
      }
      if (date) {
        Object.assign(objWhere, {[date]: {'_is_null': true}})
        await this.$apollo.query({
          query: gql(graphql.GET_DOCUMENT),
          variables: {
            where: objWhere
          },
          fetchPolicy: "no-cache"
        }).then((res) => {
          this.checkDateNull = false
          if (res.data && res.data[Object.keys(res.data)].length > 0) {
            this.checkDateNull = true
          }
        }).catch((error) => {
          console.log('ERROR: ', error)
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.codeCourt === '') this.validationErrors['codeCourt'] = 'Vui lòng nhập Mã VB tòa';
      //Khách kêu ko bắt buộc
      //if (this.numberDecision === '') this.validationErrors['numberDecision'] = 'Vui lòng nhập Quyết định số';
      if (this.contentDocument === '') this.validationErrors['contentDocument'] = 'Vui lòng nhập Nội dung văn bản';
      if (this.dateInvite === null || this.dateInvite === '') this.validationErrors['dateInvite'] = 'Vui lòng nhập Ngày mời';
      if (this.nameLitigant === null || this.nameLitigant === '') this.validationErrors['nameLitigant'] = 'Vui lòng nhập Tên đương sư';
      if (this.address === null || this.address === '') this.validationErrors['address'] = 'Vui lòng nhập Địa chỉ';
      if (this.state === null || this.state === '') this.validationErrors['state'] = 'Vui lòng nhập Tỉnh/thành';
      //if (this.district === null || this.district === '') this.validationErrors['district'] = 'Vui lòng nhập Quận/huyện';
      if (this.ward === null || this.ward === '') this.validationErrors['ward'] = 'Vui lòng nhập Phường/xã';
      // if (this.statusTD === null || this.statusTD === '') this.validationErrors['statusTD'] = 'Vui lòng Chọn Hình thức tống đạt';
      if (this.statusVB === null || this.statusVB === '') this.validationErrors['statusVB'] = 'Vui lòng Chọn Trạng thái VB';
      if (this.codeAgency === null || this.codeAgency === '') {
        this.validationErrors['codeAgency'] = 'Vui lòng nhập Mã cơ quan'
        this.cAgency_exists = false
      } else {
        await this.checkCode('office_agency', this.codeAgency)
      }
      if (this.codeOffice === '') {
        this.validationErrors['codeOffice'] = 'Vui lòng nhập Mã văn phòng'
        this.cOffice_exists = false
      } else {
        await this.checkCode('office_tpl', this.codeOffice)
      }
    },
    async saveData() {
      await this.validateData();
      if (!this.cAgency_exists && !this.cOffice_exists && Object.entries(this.validationErrors).length === 0) {
        this.$store.commit("setLoading", true);
        let budget = 0
        if (this.isFeeBudget !== null) {
          if (this.isFeeBudget === 'ybudget') budget = 1
          else budget = 2
        }

        var objects = {
          'code_court': this.codeCourt,
          'code_office': this.codeOffice,
          'is_urgent': this.isUrgent,
          'number_decision': (!this.$commonFuction.isEmpty(this.numberDecision)) ? this.numberDecision:'',
          'content_document': this.contentDocument,
          // 'date_issued': this.dateIssued,
          // 'date_invite': this.dateInvite,
          'name_litigant': this.nameLitigant,
          'address': this.address,
          'state_id': this.state && this.state.code || null,
          'district_id': this.district && this.district.code || null,
          'ward_id': this.ward && this.ward.code || null,
          'phone_litigant': this.phoneLitigant,
          'signer': this.signer,
          'code_agency': this.codeAgency,
          // 'cost_document': this.costDocument,
          'is_fee_budget': budget,
          'tdv_id': this.nameTDV && this.nameTDV.code || null,
          'phone_tdv': this.phoneTDV,
          'vplk_id': this.codeVPLK && this.codeVPLK.code || null,
          'type_document': this.type && this.type.code || 1,
          'reason_delay': this.reasonDelay,
          'note': this.note,
          // 'date_tdv_receipt': this.dateTDVReceipt.toISOString(),
          // 'date_tdv_return': this.dateTDVReturn.toISOString(),
          // 'date_dpv_receipt': this.dateDPVReceipt.toISOString(),
          // 'date_request_complete': this.dateRequestComplete.toISOString(),
          // 'date_complete': this.dateComplete.toISOString(),
          // 'date_return_court': this.dateReturnCourt.toISOString(),
          'status_vb_id': this.statusVB.code,
          'type_state': this.state.type,
          // 'status_td_id': this.statusTD.code
        }
        if (this.statusTD) {
          Object.assign(objects, {status_td_id: this.statusTD.code})
        }
        if (this.dateUpdate.length > 0) {
          Object.assign(objects, {date_invite: this.dateInvite.toISOString()})
        }
        if (this.models.status_document.id !== this.statusVB.code) {
          if (this.statusVB.code === 7) {
            // hoàn thành
            await this.checkDateVBOnServer(this.models.id, 'date_complete');
            if (this.checkDateNull) {
              this.dateComplete = new Date();
              Object.assign(objects, {date_complete: this.dateComplete.toISOString(), deadline_color: 0})
            }
            // Thêm giá của cơ quan:
            // await this.getCostDocument(this.state.code);
            // Object.assign(objects, {cost_document: this.costDocument});
          } else if (this.statusVB.code === 6) {
            await this.checkDateVBOnServer(this.models.id, 'date_request_complete');
            if (this.checkDateNull) {
              this.dateRequestComplete = new Date();
              Object.assign(objects, {date_request_complete: this.dateRequestComplete.toISOString()})
            }
          } else if (this.statusVB.code === 5) {
            await this.checkDateVBOnServer(this.models.id, 'date_dpv_receipt');
            if (this.checkDateNull) {
              this.dateDPVReceipt = new Date();
              Object.assign(objects, {date_dpv_receipt: this.dateDPVReceipt.toISOString()})
            }
          } else if (this.statusVB.code === 4) {
            await this.checkDateVBOnServer(this.models.id, 'date_tdv_return');
            if (this.checkDateNull) {
              this.dateTDVReturn = new Date();
              Object.assign(objects, {date_tdv_return: this.dateTDVReturn.toISOString()})
            }
          } else if (this.statusVB.code === 9 || this.statusVB.code === 8) {
            // trả cơ quan
            await this.checkDateVBOnServer(this.models.id, 'date_return_court');
            if (this.checkDateNull) {
              this.dateReturnCourt = new Date();
              Object.assign(objects, {date_return_court: this.dateReturnCourt.toISOString(), deadline_color: 0})
            }
            // TODO: KIỂM TRA TRỄ? NẾU ĐÚNG HẸN THÌ STATUS - VB TÍNH LƯƠNG + TÍNH FULL LƯƠNG - TRUE
            // NGƯỢC LẠI KHÔNG SET.
            await this.checkDeadline();
            if (!this.deadline) {
              objects.status_vb_id = 8;
              Object.assign(objects, this.$constants.DATA_COMMON_UPDATE_CONFIRM_SALARY)
            } else {
              // ĐÃ CÓ CRON CHẠY CHECK DEADLINE
              // Object.assign(objects, {is_late: true})
            }
            // TODO: TÍNH LƯƠNG CHO NHÂN VIÊN THEO BẢNG LƯƠNG CÀI ĐẶT.
            // MENU: BẢNG GIÁ CƠ QUAN + BẢNG GIÁ TÍNH LƯƠNG.
            //await this.getSalary(this.state.code);
            await this.getSalary(this.state.type);
            Object.assign(objects, {amount_salary: this.amountSalary})
          } else if (this.statusVB.code === 3) {
            await this.checkDateVBOnServer(this.models.id, 'date_tdv_receipt');
            if (this.checkDateNull) {
              this.dateTDVReceipt = new Date();
              Object.assign(objects, {date_tdv_receipt: this.dateTDVReceipt.toISOString()})
            }
          }
        }
        // console.log('======', objects)
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': {'_eq': this.models.id}
          }
        };
        await this.$apollo.mutate({
          mutation: DataServices.updateData('document'),
          variables: variables
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            // var returning = res.data[Object.keys(res.data)].returning[0];
            // console.log('========> SUCCESS UPDATE DOCUMENT: ', res.data)
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
            this.$router.push({ path: '/admin/report-uncomplete-late' });
          }
          this.$store.commit("setLoading", false);
        }).catch((error) => {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 3000 })
          console.error('ERROR: ', error)
        });
      }
    },
    async getCostDocument(stateID) {
      if (stateID === 9) {
        await this.$apollo.query({
          query: gql(graphql.GET_ORGAN_PRICELIST),
          variables: {
            where: {
              office_tpl_id: {'_eq': this.codeOfficeID},
              office_agency_id: {'_eq': this.codeAgencyID}
            },
            childWhere: {
              district_id: {'_eq': this.district.code}
            },
            limit: 1
          }
        }).then((res) => {
          this.costDocument = 0;
          if (res.data && res.data.organ_pricelist.length > 0) {
            let mode = res.data.organ_pricelist[0].organ_pricelist_detail[0]
            if (this.type.code === 1) this.costDocument = mode.type1
            else if (this.type.code === 2) this.costDocument = mode.type2
            else if (this.type.code === 3) this.costDocument = mode.type3
            else if (this.type.code === 4) this.costDocument = mode.type4
          }
        })
      } else {
        // Bảng giá tỉnh: lấy VB hiện tại nên ko có dữ liệu cho VB tạo mói.
        // Lúc tạo xong VB, Admin sẽ tự qua menu đó và update giá từng VB tỉnh.
      }
    },
    async getSalary(type) {
      //if (stateID === 9) {
      if (type === this.$constants.TYPE_STATE.URBAN) {
        // TRONG NỘI THÀNH (TPHCM)
        await this.$apollo.query({
          query: gql(graphql.GET_SALARY_PRICELIST),
          variables: {
            where: {
              office_tpl_id: {'_eq': this.codeOfficeID},
              //district_id: {'_eq': this.district.code},
              ward_id: {'_eq': this.ward.code}
            },
            limit: 1
          }
        }).then((res) => {
          this.amountSalary = 0
          if (res.data.salary_pricelist.length > 0) {
            let item = res.data.salary_pricelist[0]
            if (this.deadline) {
              this.amountSalary = item['type' + this.type.code + '_late'];
            } else {
              this.amountSalary = item['type' + this.type.code + '_normal'];
            }
          }
        }).catch((error) => {
          console.error('ERROR: ', error);
        })
      } else {
        // LƯƠNG TỈNH VPLK
        await this.$apollo.query({
          query: gql(graphql.GET_ORGAN_PRICELIST_PROVINCE),
          variables: {
            where: {
              office_vplk_id: {'_eq': this.codeVPLK.code},
              office_tpl_id: {'_eq': this.codeOfficeID},
              state_id: {'_eq': this.state.code}
            },
            limit: 1
          }
        }).then((res) => {
          this.amountSalary = 0;
          if (res.data && res.data.salary_pricelist_province.length > 0) {
            let item = res.data.salary_pricelist_province[0]
            if (!this.deadline) {
              // CHỈ ĐÚNG HẸN MỚI TÍNH LƯƠNG VB ĐI TỈNH
              this.amountSalary = item.price
            }
          }
        })
      }
    },
    async checkDeadline() {
      let statusID = this.statusTD && this.statusTD.code || 1;
      let denta = moment().diff(moment(new Date(this.dateReceiptCourt), 'DD-MM-YYYY'), 'days');
      // console.log('====>DENTA: ', denta);
      await this.$apollo.query({
        query: gql(graphql.GET_STATUS_TONGDAT),
        variables: {
          where: {
            id: {'_eq': statusID}
          },
          limit: 1
        }
      }).then((res) => {
        this.deadline = false;
        if (res.data.status_tongdat.length > 0) {
          let item = res.data.status_tongdat[0];
          if (denta > item.delay_time) this.deadline = true;
        }
      }).catch((error) => {
        console.error('ERROR: ', error);
      })
    },
    async getLogNiemYet(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('history_niemyet'),
        variables: {
          where_key: {
            document_id: {'_eq': id},
            deleted: {'_eq': false}
          },
          orderBy: {id: 'desc'},
          limit: 10
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      this.arrLogs = []
      if (model.length > 0) {
        this.arrLogs = model;
        for (let i = 0; i < this.arrLogs.length; i++) {
          for (let k = 0; k < this.lstObjectLog.length; k++) {
            if (this.lstObjectLog[k].code === this.arrLogs[i].object) {
              this.arrLogs[i].objectName = this.lstObjectLog[k].name;
              break;
            }
          }
          for (let g = 0; g < this.lstStatusLog.length; g++) {
            if (this.lstStatusLog[g].code === this.arrLogs[i].object) {
              this.arrLogs[i].statusName = this.lstStatusLog[g].name;
              break;
            }
          }
          this.arrLogs[i].dateSent = moment(this.arrLogs[i].date_sent).format('DD/MM/YYYY - HH:mm');
          this.arrLogs[i].dateAppointment = moment(this.arrLogs[i].date_appointment).format('DD/MM/YYYY - HH:mm')
        }
      }
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('document'),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var hasEditAfterSalaryPermission = this.$store.getters.group_permission && this.$store.getters.group_permission.edit_document_after_salary && this.$store.getters.group_permission.edit_document_after_salary.edit == true;
        if ((this.$store.getters.role == 'dpv' || this.$store.getters.role == 'court') && !hasEditAfterSalaryPermission && this.models.status_document && this.models.status_document.ordinal >= 9) {
          this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'VB đã tính lương, không có quyền chỉnh sửa', life: 3000 });
          this.$router.push({ path: '/admin/report-uncomplete-late' });
          return;
        }
        // console.log(this.models)
        this.codeSystem = this.models.code_system;
        this.codeCourt = this.models.code_court;
        this.codeOffice = this.models.code_office;
        await this.checkCode('office_tpl', this.models.code_office);
        this.isUrgent = this.models.is_urgent;
        this.numberDecision = this.models.number_decision;
        this.contentDocument = this.models.content_document;
        this.dateIssued = new Date(this.models.date_issued);
        this.dateInvite = new Date(this.models.date_invite);
        this.nameLitigant = this.models.name_litigant;
        this.address = this.models.address;
        this.state = {'code': this.models.state.id, 'name': this.models.state.name,'type': this.models.state.type};
        if(this.models.district){
          this.district = {'code': this.models.district.id, 'name': this.models.district.name};
        }
        await this.getDictrict(this.models.state.id);
        this.ward = {'code': this.models.ward.id, 'name': this.models.ward.name};
        if(!this.$commonFuction.isEmpty(this.models.district)){
          await this.getWard(this.models.district.id);
        }else{
          await this.getWard(null,this.models.state.id);
        }
        this.phoneLitigant = this.models.phone_litigant;
        this.signer = this.models.signer;
        this.codeAgency = this.models.code_agency;
        await this.checkCode('office_agency', this.models.code_agency);
        this.costDocument = this.models.cost_document;
        if (this.models.is_fee_budget === 0) this.isFeeBudget = null;
        else if (this.models.is_fee_budget === 1) this.isFeeBudget = 'ybudget';
        else this.isFeeBudget = 'nbudget';
        //Load tdv theo tỉnh khác HCM
        await this.onChangeState(1);
        //Load tvd theo phường/xa thuộc TPHCM
        await this.onChangeWard();
        this.nameTDV = this.models.tdv !== null && {'code': this.models.tdv.id, 'name': this.models.tdv.fullname, 'phone': this.models.tdv.phone} || null;
        //if (this.models.tdv.id){
        if (this.models.tdv){
          var where_tdv = {id: {_eq: this.models.tdv.id}};
          var obj_tdv = await this.$CoreService.getObjectData('users', where_tdv);
          this.phoneTDV = !this.$commonFuction.isEmpty(obj_tdv) ? obj_tdv.phone:'' ;
        }else {
          this.phoneTDV = this.models.phone_tdv;
        }
        await this.getVPLK();
        this.codeVPLK = this.models.office_vplk !== null && {'code': this.models.office_vplk.id, 'name': this.models.office_vplk.code} || null;
        for (let i = 0; i < this.typeDocs.length; i++) {
          if (this.typeDocs[i].code === this.models.type_document) this.type = {'code': this.models.type_document, 'name': this.typeDocs[i].name}
        }
        await this.getStatusVB(this.models.status_document.ordinal);
        this.statusVB = this.models.status_document !== null && {'code': this.models.status_document.id, 'name': this.models.status_document.name} || null;
        await this.getStatusTD();
        this.statusTD = this.models.status_tongdat !== null && {'code': this.models.status_tongdat.id, 'name': this.models.status_tongdat.name} || null;
        this.dateReceiptCourt = new Date(this.models.date_receipt_court);
        this.dateTDVReceipt = this.models.date_tdv_receipt !== null && new Date(this.models.date_tdv_receipt) || null;
        this.dateTDVReturn = this.models.date_tdv_return !== null && new Date(this.models.date_tdv_return) || null;
        this.dateDPVReceipt = this.models.date_dpv_receipt && new Date(this.models.date_dpv_receipt) || null;
        this.dateRequestComplete = this.models.date_request_complete !== null && new Date(this.models.date_request_complete) || null;
        this.dateComplete = this.models.date_complete !== null && new Date(this.models.date_complete) || null;
        this.dateReturnCourt = this.models.date_return_court !== null && new Date(this.models.date_return_court) || null;
        this.dateValue = this.$CoreService.convertDateValueDoc(this.models);
        this.note = this.models.note;
        this.reasonDelay = this.models.reason_delay;
        await this.getLogNiemYet(id);
        await this.getListUserTDV();
      }
    },
    async getListUserTDV() {
      var model = await this.$CoreService.getListUserTDV();
      if (model.length > 0) {
      this.arrTDV = model;
      this.countTDV++;
      }
    },
    async getState() {
      var listState = await this.$CoreService.getListState();
      this.arrState = listState;
      if (listState.length>0){
        this.countState++;
      }
    },
    async getDictrict(stateID) {
      var model =await this.$CoreService.getDistrictByIdStateSelect(stateID);
      if(model.length>0){
        this.arrDistrict = model;
        this.countDistrict++;
      }
    },
    async getWard(districtID,state_id=null) {
      var model =await this.$CoreService.getWardByIdDistrictSelect(districtID,state_id);
      if(model.length>0){
        this.arrWard = model;
        this.countWard++;
      }
    },
    async getVPLK() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('office_vplk', {"fields" : "id name code"}),
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrVPLK = [];
        for (let i = 0; i < model.length; i++) {
          this.arrVPLK.push({'code': model[i].id, 'name': model[i].code})
        }
        this.countVPLK++;
      }
    },
    async getStatusVB(ordinal) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('status_document', {"fields" : "id name ordinal"}),
        variables: {
          where_key: {
            ordinal: {'_gte': ordinal}
          },
          orderBy: {ordinal: 'asc'}
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrStatusVB = [];
        for (let i = 0; i < model.length; i++) {
          this.arrStatusVB.push({'code': model[i].id, 'name': model[i].name})
        }
        this.countSVB++;
      }
    },
    async getStatusTD() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('status_tongdat', {"fields" : "id name"}),
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrStatusTD = [];
        for (let i = 0; i < model.length; i++) {
          this.arrStatusTD.push({'code': model[i].id, 'name': model[i].name})
        }
        this.countSTD++;
      }
    },
    /*async onChangeState(e) {
      this.arrDistrict = []
      this.arrWard = []
      if (e.value !== null) await this.getDictrict(e.value.code);
    },*/
    /**
     is_load =1 load lại trang ,0change state
     */
    async onChangeState(is_load=0) {
      if (is_load==0){
        this.district = null;
          this.ward = null;
        this.arrDistrict = []
        this.arrWard = []
      }
      if (this.state !== null) {
        if (is_load==0) {
          await this.getDictrict(this.state.code);
          await this.getWard(null,this.state.code);
          //load danh sách VPLK
          this.loadVPLK();
        }
        //console.log(this.state)
        if (this.state.type == this.$constants.TYPE_STATE.OUTSIDE){
          //Nếu khác TP HCM thì load danh sách tống đạt viên theo tỉnh thành
         /* var {data} = await this.$apollo.query({
            query: gql(graphql.GET_USERS_STATE),
            variables: {
              where: {
                state_id : {'_eq': this.state.code},
                user: {
                  users_account: {
                    role: {'_eq': 'tdv'}
                  }
                }
              },
              distinct_on: "user_id"
            },
            fetchPolicy: "network-only"
          })
          var model = data[Object.keys(data)];
          this.arrTDV = [];
          if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
              this.arrTDV.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
            }
            this.countTDV++;
          }*/
          // var listUserState =await this.$CoreService.getListUserState(this.state.code);
          var listUserState =await this.$CoreService.getListUserState(null);
          // this.arrTDV = listUserState;
          if (listUserState.length > 0) {
            this.countTDV++;
          }
        //   Nếu là thành phố thì lấy danh sách TDV của phường theo mã tỉnh (state.code)
        } else if (this.state.type == this.$constants.TYPE_STATE.URBAN) {
          // var listUserStateUrban = await this.$CoreService.getListUserWardByState(this.state.code);
          var listUserStateUrban = await this.$CoreService.getListUserWardByState(null);
          // this.arrTDV = listUserStateUrban;
          if (listUserStateUrban.length > 0) {
            this.countTDV++;
          }
        }
      }
    },
    async onChangeDistrict(e) {
      //console.log("onChangeDistrict:",e.value);
      console.log("onChangeDistrict:");
      this.arrWard = []
      this.ward = null;
      if (e.value !== null){
        await this.getWard(e.value.code);
      }else {
        if(this.state){
          await this.getWard(null,this.state.code);
        }
      }
    },
    /*async onChangeWard() {
      var {data} = await this.$apollo.query({
        query: gql(graphql.GET_USERS_WARD),
        variables: {
          where: {
            ward_id: {'_eq': this.ward && this.ward.code || null},
            user: {
              users_account: {
                role: {'_eq': 'tdv'}
              }
            }
          },
          distinct_on: "user_id"
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.arrTDV = [];
        for (let i = 0; i < model.length; i++) {
          this.arrTDV.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
        }
        this.countTDV++;
      }
    },*/
    async onChangeWard() {
      if (this.state){
        if (this.state.type == this.$constants.TYPE_STATE.URBAN){
          var listUserWard = await this.$CoreService.getListUserWard(this.ward.code);
          this.arrTDV = listUserWard;
          if (listUserWard.length > 0){
            this.countTDV++;
          }
        }
      }

    },
    async onChangeTDV(e) {
      if(e.value !== null && e.value.phone){
        this.phoneTDV = e.value.phone;
      }else{
        this.phoneTDV = null;
      }
    },
    async onChangeTTVB(e, key) {
      if (key === 'vb') {
        if (e.value !== null && 'statusVB' in this.validationErrors) delete this.validationErrors.statusVB;
      } else if (key === 'td') {
        if (e.value === null && 'statusTD' in this.validationErrors) delete this.validationErrors.statusTD;
      }
    },
    async onChangeDate(e, type) {
      // console.log(e, type)
      if (!this.dateUpdate.includes(type)) {
        this.dateUpdate.push(type)
      }
    }
  },
  async created() {
    await this.getState();
  },
  apollo: {
    // arrState: {
    //   query() {
    //     return DataServices.getList('state', {"fields" : "id name"});
    //   },
    //   update(data) {
    //     return data[Object.keys(data)];
    //   },
    //   fetchPolicy: "network-only"
    // },
    // arrDistrict: {
    //   query() {
    //     return DataServices.getList('district', {"fields" : "id name"});
    //   },
    //   update(data) {
    //     return data[Object.keys(data)];
    //   },
    //   fetchPolicy: "network-only"
    // },
    // arrWard: {
    //   query() {
    //     return DataServices.getList('ward', {"fields" : "id name"});
    //   },
    //   update(data) {
    //     return data[Object.keys(data)];
    //   },
    //   fetchPolicy: "network-only"
    // }
  }
}
</script>

<style lang="scss">
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    // span {font-size: 24px;}
  }
}
.custom-disabled {
  background: #E5E8EB !important;
  .p-inputtext {
    background: #E5E8EB !important;
  }
  .p-dropdown-trigger {
    background: #E5E8EB !important;
  }
}
.status-vb, .status-td {
  border: 1px solid #32D74B;
  .p-dropdown-label {
    background: #32D74B !important;
    color: white;
    font-weight: bold;
  }
  .p-dropdown-trigger {
    background: #32D74B !important;
    .p-dropdown-trigger-icon {color: white;}
  }
  .p-dropdown-clear-icon {
    color: white;
  }
}
.block {
  .block-left {
    .block-title {
      font-weight: bold;
      font-size: 20px;
    }
    .block-history {
      .obj-title {font-weight: bold; font-size: 16px;margin-bottom: 8px;
        // &:nth-child(2n+1) {
        //   margin-top: 10px;
        // }
      }
      .obj-item {display: flex; justify-content: space-between;}
    }
  }
  .block-right {
    .block-title {
      font-weight: bold;
      font-size: 20px;
    }
  }
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
